/* Gastronom — theme behaviour.
   Deliberately dependency-free: the only bundled JS on the site is the Caviar
   Atelier, and it only loads on that one template. */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------ reveals -- */
  // Stands in for the demo's Motion viewport animations: same rise, same
  // easing, no library.
  function observeReveals(root) {
    var els = $$(".reveal:not(.is-in)", root || document);
    if (!els.length) return;
    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.05 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------- ranges -- */
  // WebKit gives no way to paint the track before the thumb, so `.range` draws
  // the filled portion from a `--range-p` fraction. Keep it in sync here rather
  // than in each feature that happens to own a slider.
  function paintRange(el) {
    var min = Number(el.min || 0);
    var span = Number(el.max || 100) - min;
    el.style.setProperty("--range-p", span > 0 ? (Number(el.value) - min) / span : 1);
  }
  $$("input.range").forEach(function (el) {
    paintRange(el);
    el.addEventListener("input", function () { paintRange(el); });
  });
  // Anything that sets `.value` programmatically (the filter reset) can call
  // this instead of reaching for the private helper.
  window.GastronomRange = { paint: paintRange };

  /* -------------------------------------------------------------- rails -- */
  // The rail scrolls natively; this only adds the arrows and the edge fades,
  // and gets out of the way when everything already fits on screen.
  $$("[data-rail]").forEach(function (rail) {
    var frame = rail.closest("[data-rail-frame]");
    var controls = $('[data-rail-controls="' + rail.dataset.rail + '"]');
    var prev = controls && $("[data-rail-prev]", controls);
    var next = controls && $("[data-rail-next]", controls);

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var overflowing = max > 4;
      if (controls) controls.classList.toggle("lg:flex", overflowing);
      if (frame) {
        frame.dataset.atStart = String(rail.scrollLeft <= 4);
        frame.dataset.atEnd = String(rail.scrollLeft >= max - 4);
      }
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft >= max - 4;
    }

    // One card plus its gap, so a click lands the next card on the snap point.
    function step() {
      var card = rail.firstElementChild;
      if (!card) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step() * 2, behavior: reduced ? "auto" : "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step() * 2, behavior: reduced ? "auto" : "smooth" }); });

    // Cards further along a rail sit outside the viewport horizontally, so the
    // reveal observer never fires for them and they stay at opacity 0 — a
    // shopper scrolling the rail meets blank cards. A horizontal fade adds
    // nothing anyway, so show a rail's contents immediately.
    $$(".reveal", rail).forEach(function (el) { el.classList.add("is-in"); });

    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    // Card images load lazily and change the scroll width as they arrive.
    if ("ResizeObserver" in window) new ResizeObserver(sync).observe(rail);
    sync();
  });

  /* ------------------------------------------------------------- header -- */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("border-b", window.scrollY > 12);
      header.classList.toggle("border-ink/8", window.scrollY > 12);
      header.classList.toggle("bg-parchment/88", window.scrollY > 12);
      header.classList.toggle("backdrop-blur-xl", window.scrollY > 12);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var mega = $("[data-megamenu]");
    var megaBtn = $("[data-megamenu-toggle]");
    var chevron = $("[data-chevron]");
    var megaOpen = false;
    var setMega = function (open) {
      megaOpen = open;
      if (!mega) return;
      mega.dataset.open = String(open);
      mega.setAttribute("aria-hidden", String(!open));
      if (megaBtn) megaBtn.setAttribute("aria-expanded", String(open));
      if (chevron) chevron.classList.toggle("rotate-180", open);
    };
    if (megaBtn) {
      megaBtn.addEventListener("click", function () { setMega(!megaOpen); });
      megaBtn.addEventListener("mouseenter", function () { setMega(true); });
    }
    header.addEventListener("mouseleave", function () { setMega(false); });
    // Mouse users get `mouseleave`; keyboard users need Escape and a close when
    // focus tabs out of the panel entirely.
    header.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && megaOpen) {
        setMega(false);
        if (megaBtn) megaBtn.focus();
      }
    });
    header.addEventListener("focusout", function (e) {
      if (megaOpen && !header.contains(e.relatedTarget)) setMega(false);
    });

    var mobile = $("[data-mobile-menu]");
    var mobileBtn = $("[data-mobile-toggle]");
    if (mobileBtn && mobile) {
      mobileBtn.addEventListener("click", function () {
        var nowOpen = mobile.classList.toggle("hidden") === false;
        mobileBtn.setAttribute("aria-expanded", String(nowOpen));
      });
    }

    var searchPanel = $("[data-search-panel]");
    var searchInput = $("[data-search-input]");
    if (searchPanel) {
      var searchOpener = null;
      var setSearch = function (open) {
        searchPanel.classList.toggle("is-search-open", open);
        $$("[data-search-open]").forEach(function (b) {
          b.setAttribute("aria-expanded", String(open));
        });
        if (open && searchInput) searchInput.focus();
        // Send focus back where it came from, or it lands at the top of the
        // document and the visitor has to tab through the whole header again.
        if (!open && searchOpener && document.contains(searchOpener)) {
          searchOpener.focus();
          searchOpener = null;
        }
      };
      $$("[data-search-open]").forEach(function (b) {
        b.addEventListener("click", function () {
          searchOpener = b;
          setSearch(!searchPanel.classList.contains("is-search-open"));
        });
      });
      searchPanel.addEventListener("click", function (e) {
        if (e.target.closest("button, input, a")) return;
        if (!searchPanel.classList.contains("is-search-open")) {
          searchOpener = null;
          setSearch(true);
        }
      });
      $$("[data-search-close]").forEach(function (b) {
        b.addEventListener("click", function () { setSearch(false); });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && searchPanel.classList.contains("is-search-open")) setSearch(false);
      });

      /* ------------------------------------------- predictive search -- */
      var results = $("[data-search-results]", searchPanel);
      var searchTimer = null;
      var lastQuery = "";

      function renderResults(items, query) {
        if (!items.length) {
          results.innerHTML =
            '<p class="py-3 text-[0.86rem] text-ink-soft">Nothing matched &ldquo;' +
            query.replace(/[<>&]/g, "") + '&rdquo;.</p>';
          results.classList.remove("hidden");
          return;
        }
        results.innerHTML =
          '<ul class="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">' +
          items
            .map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '&width=120" alt="" width="56" height="56" class="h-14 w-14 shrink-0 rounded-lg object-contain">'
                : '<span class="h-14 w-14 shrink-0 rounded-lg bg-linen"></span>';
              return (
                '<li><a href="' + p.url + '" class="flex items-center gap-3 rounded-xl p-2 transition-colors hover:bg-linen/70">' +
                img +
                '<span class="min-w-0"><span class="block truncate font-display text-[0.92rem]">' + p.title + "</span>" +
                // suggest.json returns a bare number ("22.49") — add the symbol.
                '<span class="mt-0.5 block text-[0.8rem] tabular-nums text-ink-soft">' +
                (/^[\d.,]+$/.test(String(p.price)) ? "$" + p.price : p.price) +
                "</span></span></a></li>"
              );
            })
            .join("") +
          "</ul>" +
          '<a href="/search?q=' + encodeURIComponent(query) +
          '" class="mt-4 inline-block text-[0.84rem] font-medium text-olive underline underline-offset-4">See all results &rarr;</a>';
        results.classList.remove("hidden");
      }

      if (results && searchInput) {
        searchInput.addEventListener("input", function () {
          var q = searchInput.value.trim();
          clearTimeout(searchTimer);
          if (q.length < 2) {
            results.classList.add("hidden");
            return;
          }
          // Something has to acknowledge the keystroke, or the panel sits blank
          // for the debounce plus the round trip and reads as broken.
          if (!results.dataset.loaded || lastQuery !== q) {
            results.innerHTML =
              '<p class="py-3 text-[0.86rem] text-ink-soft/70">Looking&hellip;</p>';
            results.classList.remove("hidden");
          }
          // Debounced so typing does not fire a request per keystroke.
          searchTimer = setTimeout(function () {
            if (q === lastQuery) return;
            lastQuery = q;
            fetch(
              "/search/suggest.json?q=" + encodeURIComponent(q) +
                "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last"
            )
              .then(function (r) { return r.json(); })
              .then(function (d) {
                var items = ((d.resources || {}).results || {}).products || [];
                renderResults(items, q);
              })
              .catch(function () { results.classList.add("hidden"); });
          }, 220);
        });
      }
    }
  }

  /* ------------------------------------------------------- announcement -- */
  // Dismissal persists so the bar does not nag on every page load.
  var ann = $("[data-announcement]");
  if (ann) {
    try {
      if (localStorage.getItem("gastronom.announcement.dismissed") === "1") ann.remove();
    } catch (e) {
      /* private browsing — the bar simply stays */
    }
    // Cycle the messages. Pauses on hover so a link can actually be clicked,
    // and does not run at all under reduced motion or with one message.
    var annItems = $$("[data-announcement-item]", ann);
    if (annItems.length > 1 && !reduced) {
      var annIndex = 0;
      var annTimer = setInterval(function () {
        annItems[annIndex].classList.add("opacity-0", "pointer-events-none");
        annIndex = (annIndex + 1) % annItems.length;
        annItems[annIndex].classList.remove("opacity-0", "pointer-events-none");
      }, (Number(ann.dataset.rotate) || 5) * 1000);
      ann.addEventListener("mouseenter", function () { clearInterval(annTimer); });
    }

    var annClose = $("[data-announcement-close]", ann);
    if (annClose)
      annClose.addEventListener("click", function () {
        ann.remove();
        try {
          localStorage.setItem("gastronom.announcement.dismissed", "1");
        } catch (e) {}
      });
  }

  /* --------------------------------------------------------------- cart -- */
  var overlay = $("[data-cart-overlay]");
  var drawer = $("[data-cart-drawer]");
  var body = $("[data-cart-body]");
  var emptyTpl = $("[data-cart-empty-template]");

  function money(cents) {
    return "$" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function splitTitle(title) {
    var m = title.match(/^(.*?)\s+[–—-]\s+(.*)$/);
    return m ? { name: m[1], size: m[2] } : { name: title, size: "" };
  }

  // The drawer is slid off-screen rather than hidden, so without `inert` its
  // close button and checkout button stay in the tab order while it is shut —
  // a keyboard visitor tabs into controls they cannot see. Marking the rest of
  // the page inert while it is open gives a focus trap for free.
  var pageRegions = ["[data-header]", "main", "footer", "[data-announcement]", "[data-skip-link]"];
  var cartOpener = null;

  function setInert(el, on) {
    if (!el) return;
    if ("inert" in HTMLElement.prototype) el.inert = on;
    else if (on) el.setAttribute("aria-hidden", "true");
    else el.removeAttribute("aria-hidden");
  }

  function setCartOpen(open) {
    if (!drawer || !overlay) return;
    if (open) cartOpener = document.activeElement;
    overlay.classList.toggle("hidden", !open);
    document.body.style.overflow = open ? "hidden" : "";
    setInert(drawer, !open);
    pageRegions.forEach(function (sel) { setInert($(sel), open); });
    requestAnimationFrame(function () {
      overlay.classList.toggle("opacity-0", !open);
      drawer.classList.toggle("translate-x-full", !open);
    });
    if (open) {
      var close = $("[data-cart-close]", drawer);
      if (close) close.focus();
    } else if (cartOpener && document.contains(cartOpener)) {
      cartOpener.focus();
      cartOpener = null;
    }
  }

  // Shut on load: the markup ships open-to-the-keyboard so it still works
  // without JS having run.
  setInert(drawer, true);

  function renderCart(cart) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle("hidden", cart.item_count === 0);
    });
    var titleCount = $("[data-cart-title-count]");
    if (titleCount) titleCount.textContent = "(" + cart.item_count + ")";
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = "";
      if (emptyTpl) body.appendChild(emptyTpl.content.cloneNode(true));
      return;
    }

    var rows = cart.items
      .map(function (item) {
        var t = splitTitle(item.product_title);
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") +
            '" alt="" class="h-full w-full scale-90 object-contain">'
          : "";
        return (
          '<li class="flex gap-4 py-4">' +
          '<a href="' + item.url + '" class="plate h-20 w-20 shrink-0 rounded-xl bg-linen/70">' + img + "</a>" +
          '<div class="flex min-w-0 flex-1 flex-col">' +
          '<a href="' + item.url + '" class="font-display text-[0.95rem] leading-tight hover:text-olive">' + t.name + "</a>" +
          (t.size ? '<p class="mt-0.5 text-[0.72rem] text-ink-soft">' + t.size + "</p>" : "") +
          '<div class="mt-auto flex items-center justify-between pt-2">' +
          '<div class="flex items-center rounded-full border border-ink/15">' +
          '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity" class="grid h-11 w-11 place-items-center rounded-full text-ink-soft hover:bg-linen hover:text-ink">&minus;</button>' +
          '<span class="w-6 text-center text-sm tabular-nums">' + item.quantity + "</span>" +
          '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity" class="grid h-11 w-11 place-items-center rounded-full text-ink-soft hover:bg-linen hover:text-ink">+</button>' +
          "</div>" +
          '<span class="text-sm font-semibold tabular-nums">' + money(item.final_line_price) + "</span>" +
          "</div></div>" +
          '<button type="button" data-qty="' + item.key + '" data-to="0" aria-label="Remove" class="grid h-11 w-11 self-start place-items-center rounded-full text-ink-soft/60 transition-colors hover:bg-linen hover:text-ink">' +
          '<svg viewBox="0 0 24 24" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 5l14 14M19 5L5 19" stroke-linecap="round"/></svg>' +
          "</button></li>"
        );
      })
      .join("");

    // Free-shipping progress. Threshold comes from the cart drawer markup so it
    // stays editable in the theme editor rather than hard-coded here.
    var threshold = Number(document.querySelector("[data-free-shipping]")?.dataset.threshold || 0);
    var ship = "";
    if (threshold > 0) {
      var remaining = threshold - cart.total_price;
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      var unlocked = remaining <= 0;
      ship =
        '<div class="border-b border-ink/8 bg-linen/45 px-6 py-5">' +
        '<p class="flex items-center gap-2 text-[0.8rem] text-ink-soft">' +
        (unlocked
          ? '<svg viewBox="0 0 20 20" class="h-4 w-4 shrink-0 text-olive" fill="none" stroke="currentColor" stroke-width="1.9"><path d="m4 10.5 4 4 8-9" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '<strong class="font-semibold text-olive">FREE SHIPPING on orders $599 and up.</strong>'
          : '<span><strong class="font-semibold text-ink">' + money(remaining) + "</strong> away. FREE SHIPPING on orders $599 and up.</span>") +
        "</p>" +
        '<div class="mt-3 h-1.5 overflow-hidden rounded-full bg-ink/10">' +
        '<div class="h-full rounded-full ' +
        (unlocked ? "bg-olive" : "bg-gradient-to-r from-olive/70 to-olive") +
        ' transition-[width] duration-700 ease-out" style="width:' + pct + '%"></div>' +
        "</div></div>";
    }

    body.innerHTML =
      ship +
      '<ul class="flex-1 divide-y divide-ink/8 overflow-y-auto px-6">' + rows + "</ul>" +
      '<footer class="border-t border-ink/10 px-6 py-5">' +
      '<div class="flex items-baseline justify-between"><span class="text-sm text-ink-soft">Subtotal</span>' +
      '<span class="font-display text-2xl font-medium tabular-nums">' + money(cart.total_price) + "</span></div>" +
      '<p class="mt-1 text-[0.72rem] text-ink-soft">Shipping and taxes calculated at checkout.</p>' +
      '<form action="/cart" method="post"><button type="submit" name="checkout" class="mt-4 w-full rounded-full bg-olive py-3.5 text-sm font-semibold uppercase tracking-[0.12em] text-parchment transition-colors hover:bg-olive-deep">Checkout</button></form>' +
      // A way back that is not the X. Closing the drawer is the common intent
      // after adding something, and the only control for it was a 9px glyph in
      // the far corner.
      '<button type="button" data-cart-close class="mt-3 w-full text-center text-[0.78rem] font-medium text-ink-soft underline underline-offset-4 transition-colors hover:text-olive">Continue shopping</button>' +
      "</footer>";
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  window.GastronomCart = {
    open: function () { setCartOpen(true); fetchCart(); },
    add: function (variantId, quantity) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { setCartOpen(true); return fetchCart(); });
    },
    refresh: fetchCart,
  };

  $$("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function () { window.GastronomCart.open(); });
  });
  if (overlay) overlay.addEventListener("click", function () { setCartOpen(false); });
  // Delegated: the drawer body is re-rendered after every change, so a close
  // control inside it (the "Continue shopping" link) would never be bound by a
  // listener attached at load.
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-close]")) setCartOpen(false);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setCartOpen(false);
  });

  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      add.disabled = true;
      window.GastronomCart.add(add.dataset.variantId, Number(add.dataset.quantity || 1)).finally(
        function () { add.disabled = false; }
      );
      return;
    }
    var qty = e.target.closest("[data-qty]");
    if (qty && body && body.contains(qty)) {
      e.preventDefault();
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: qty.dataset.qty, quantity: Number(qty.dataset.to) }),
      })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    }
  });

  /* ------------------------------------------- product quantity stepper -- */
  var stepper = $("[data-qty-stepper]");
  if (stepper) {
    var out = $("[data-qty-value]", stepper);
    // Only this product's two buttons — the related and pairing rails on the
    // same page are full of [data-add-to-cart] cards that must stay at 1.
    var addBtns = $$("[data-buy-block] [data-add-to-cart], [data-buy-bar-button]");
    var max = Number(stepper.dataset.max || 99);
    var n = 1;
    var paint = function () {
      out.textContent = n;
      addBtns.forEach(function (b) { b.dataset.quantity = n; });
      $$('[data-accelerated-quantity]').forEach(function (input) { input.value = n; });
      if (!stepper.dataset.price) return;
      var total = money(Number(stepper.dataset.price) * n);
      $$("[data-qty-price], [data-buy-bar-price]").forEach(function (el) { el.textContent = total; });
    };
    $$("[data-step]", stepper).forEach(function (b) {
      b.addEventListener("click", function () {
        n = Math.min(max, Math.max(1, n + Number(b.dataset.step)));
        paint();
      });
    });
    paint();
  }

  /* ----------------------------------------- native product sharing -- */
  var shareProduct = $('[data-share-product]');
  if (shareProduct) {
    shareProduct.addEventListener('click', function () {
      var label = $('[data-share-product-label]', shareProduct);
      var shareData = { title: document.title, url: location.href };
      var copyFallback = function () {
        if (!navigator.clipboard || !navigator.clipboard.writeText) return;
        navigator.clipboard.writeText(location.href).then(function () {
          if (!label) return;
          var original = shareProduct.dataset.shareLabel;
          label.textContent = shareProduct.dataset.shareCopied;
          window.setTimeout(function () { label.textContent = original; }, 1800);
        });
      };
      if (navigator.share) {
        navigator.share(shareData).catch(function (error) {
          if (error && error.name !== 'AbortError') copyFallback();
        });
      } else {
        copyFallback();
      }
    });
  }

  /* ------------------------------------------ collection client filters -- */
  var filters = $("[data-filters]");
  if (filters) {
    var grid = $("[data-product-grid]");
    var priceInput = $("[data-filter-price]", filters);
    var priceOut = $("[data-filter-price-out]", filters);
    var stockInput = $("[data-filter-stock]", filters);
    // Two of these now: the toolbar count and the sheet's "Show N products".
    var countOuts = $$("[data-filter-count]");

    // Declared before `apply` so the first call can set the button's state —
    // `var` hoisting would otherwise leave it undefined on that first run.
    var toggle = $("[data-filters-toggle]");
    var backdrop = $("[data-filters-backdrop]");

    var apply = function () {
      var cap = priceInput ? Number(priceInput.value) : Infinity;
      var stockOnly = stockInput ? stockInput.checked : false;
      var shown = 0;
      $$("[data-price]", grid).forEach(function (card) {
        var price = Number(card.dataset.price) / 100;
        var avail = card.dataset.available === "true";
        var ok = price <= cap && (!stockOnly || avail);
        card.classList.toggle("hidden", !ok);
        if (ok) shown++;
      });
      if (priceOut) priceOut.textContent = money(cap * 100);
      countOuts.forEach(function (el) { el.textContent = shown; });

      // On a phone the panel is closed most of the time, so the only way to
      // tell a filter is on was that the grid looked short. Mark the button.
      var active = (priceInput && Number(priceInput.value) < Number(priceInput.max)) || stockOnly;
      if (toggle) {
        toggle.classList.toggle("border-olive", active);
        toggle.classList.toggle("bg-olive", active);
        toggle.classList.toggle("text-parchment", active);
        toggle.classList.toggle("border-ink/15", !active);
        var dot = $("[data-filters-active]", toggle);
        if (dot) dot.classList.toggle("hidden", !active);
      }
      var empty = $("[data-filter-empty]");
      if (empty) empty.classList.toggle("hidden", shown > 0);
    };
    if (priceInput) priceInput.addEventListener("input", apply);
    if (stockInput) stockInput.addEventListener("change", apply);
    var reset = $("[data-filter-reset]");
    if (reset)
      reset.addEventListener("click", function () {
        if (priceInput) {
          priceInput.value = priceInput.max;
          paintRange(priceInput);
        }
        if (stockInput) stockInput.checked = false;
        apply();
      });
    apply();

    /* Below `lg` the panel is a bottom sheet — see `.filter-sheet`. Above it,
       `hidden lg:block` keeps the sidebar visible and none of this runs. */
    var filtersOpener = null;

    function setFilters(open) {
      filters.classList.toggle("hidden", !open);
      filters.classList.toggle("filter-sheet", open);
      if (backdrop) backdrop.classList.toggle("hidden", !open);
      if (toggle) toggle.setAttribute("aria-expanded", String(open));
      document.body.style.overflow = open ? "hidden" : "";
      if (open) {
        var first = $("[data-filters-close]", filters);
        if (first) first.focus();
      } else if (filtersOpener && document.contains(filtersOpener)) {
        filtersOpener.focus();
        filtersOpener = null;
      }
    }

    if (toggle) {
      toggle.setAttribute("aria-expanded", "false");
      toggle.addEventListener("click", function () {
        filtersOpener = toggle;
        setFilters(filters.classList.contains("hidden"));
      });
    }
    $$("[data-filters-close]").forEach(function (b) {
      b.addEventListener("click", function () { setFilters(false); });
    });
    if (backdrop) backdrop.addEventListener("click", function () { setFilters(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && filters.classList.contains("filter-sheet")) setFilters(false);
    });
  }

  /* --------------------------------------------------------- to top -- */
  var toTop = $("[data-to-top]");
  if (toTop) {
    // Appears after two screens, so it never competes with the hero.
    var trackTop = function () {
      var show = window.scrollY > window.innerHeight * 2;
      toTop.classList.toggle("opacity-0", !show);
      toTop.classList.toggle("translate-y-3", !show);
      toTop.classList.toggle("pointer-events-none", !show);
      toTop.inert = !show;
    };
    toTop.inert = true;
    window.addEventListener("scroll", trackTop, { passive: true });
    toTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
    });
    trackTop();
  }

  /* ---------------------------------------------------------- buy bar -- */
  // Shows only once the real Add to bag button has scrolled out of view, so
  // the two are never on screen together.
  var buyBar = $("[data-buy-bar]");
  var buyBlock = $("[data-buy-block]");
  if (buyBar && buyBlock) {
    var showBar = function (show) {
      buyBar.classList.toggle("translate-y-full", !show);
      buyBar.classList.toggle("pointer-events-none", !show);
      // Translated off-screen is still tabbable — the same trap the cart
      // drawer had. `setInert` is defined with the drawer below; guard for it
      // in case this block ever moves above it.
      if (typeof setInert === "function") setInert(buyBar, !show);
      else buyBar.inert = !show;
    };
    buyBar.inert = true;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (entries) {
          showBar(!entries[0].isIntersecting);
        },
        { rootMargin: "0px 0px -20px 0px" }
      ).observe(buyBlock);
    }
  }

  /* ------------------------------------------------------------ contact -- */
  // One detail field serves two reasons — which product, or which page is
  // broken — so the label swaps rather than stacking a second input. Ships
  // visible and is hidden here, so a JS failure leaves a spare optional field
  // rather than removing a needed one.
  var reason = $("[data-contact-reason]");
  var detail = $("[data-contact-detail]");
  if (reason && detail) {
    var label = $("[data-contact-detail-label]", detail);
    var input = $("[data-contact-detail-input]", detail);
    var COPY = {
      "Request a product": ['Which product? <span class="font-normal normal-case tracking-normal">Brand, size, anything you know</span>', "e.g. Wedel Ptasie Mleczko, 340g"],
      "Website bug": ['Where did it happen? <span class="font-normal normal-case tracking-normal">Page, and what went wrong</span>', "e.g. cart page, quantity buttons do nothing"]
    };
    var syncReason = function () {
      var copy = COPY[reason.value];
      detail.hidden = !copy;
      if (copy) {
        if (label) label.innerHTML = copy[0];
        if (input) input.placeholder = copy[1];
      } else if (input) {
        input.value = "";
      }
    };
    reason.addEventListener("change", syncReason);
    // Let a link preselect a reason: /pages/contact?reason=Website+bug
    var wanted = new URLSearchParams(location.search).get("reason");
    if (wanted) {
      for (var i = 0; i < reason.options.length; i++) {
        if (reason.options[i].value === wanted) { reason.selectedIndex = i; break; }
      }
    }
    syncReason();
  }

  /* ------------------------------------------------------------ article -- */
  var progress = $("[data-reading-progress]");
  if (progress) {
    var tick = function () {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      var p = scrollable > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollable)) : 0;
      progress.style.transform = "scaleX(" + p + ")";
    };
    window.addEventListener("scroll", tick, { passive: true });
    window.addEventListener("resize", tick);
    tick();
  }

  $$("[data-copy-link]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var url = btn.dataset.url || window.location.href;
      var done = function () {
        // Swap the glyph for a tick rather than popping a toast — the button
        // is small and the confirmation belongs where the click happened.
        var svg = $("svg", btn);
        if (!svg || btn.dataset.copied) return;
        btn.dataset.copied = "1";
        var original = svg.innerHTML;
        svg.innerHTML = '<path d="m5 12.5 4.2 4.5L19 7" stroke-linecap="round" stroke-linejoin="round"/>';
        btn.classList.add("border-olive/45", "text-olive");
        setTimeout(function () {
          svg.innerHTML = original;
          btn.classList.remove("border-olive/45", "text-olive");
          delete btn.dataset.copied;
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {});
        return;
      }
      // Older Safari and any non-secure context land here.
      var tmp = document.createElement("input");
      tmp.value = url;
      document.body.appendChild(tmp);
      tmp.select();
      try { document.execCommand("copy"); done(); } catch (e) {}
      document.body.removeChild(tmp);
    });
  });

  /* ---------------------------------------------------- recently viewed -- */
  var HISTORY_KEY = "gastronom.viewed.v1";

  function readHistory() {
    try {
      return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  // Record the current product, most-recent first, capped so the list cannot
  // grow unbounded in storage.
  var current = $("[data-add-to-cart][data-variant-id]");
  var pdp = $("[data-qty-stepper]");
  if (current && pdp) {
    var handle = location.pathname.split("/products/")[1];
    if (handle) {
      handle = handle.split("?")[0].split("#")[0];
      var hist = readHistory().filter(function (h) { return h !== handle; });
      hist.unshift(handle);
      try {
        localStorage.setItem(HISTORY_KEY, JSON.stringify(hist.slice(0, 12)));
      } catch (e) {}
    }
  }

  var rv = $("[data-recently-viewed]");
  if (rv) {
    var grid = $("[data-recently-viewed-grid]", rv);
    var exclude = rv.dataset.exclude;
    var limit = Number(rv.dataset.limit || 4);
    var wanted = readHistory()
      .filter(function (h) { return h && h !== exclude; })
      .slice(0, limit);

    if (wanted.length >= 2) {
      Promise.all(
        wanted.map(function (h) {
          return fetch("/products/" + h + "?view=card")
            .then(function (r) { return r.ok ? r.text() : ""; })
            .catch(function () { return ""; });
        })
      ).then(function (chunks) {
        var html = chunks.filter(Boolean).join("");
        if (!html) return;
        grid.innerHTML = html;
        rv.classList.remove("hidden");
        observeReveals(rv);
      });
    }
  }

  observeReveals();
  document.addEventListener("shopify:section:load", function (e) { observeReveals(e.target); });
})();
